module.exports = __webpack_public_path__ + "img/maimex.2a6738c9.jpeg";